module.exports = __webpack_public_path__ + "img/orange_093.320a2cc0.png";